export default __webpack_public_path__ + "static/media/caret-next-14px-26282A.b9d931a4.svg";